<div class="scrollable-content-wrap"
     [style.backgroundColor]="backgroundColor">
  <ng-content></ng-content>
</div>
